export default {
  title: "Sobre nosotros",
  mission_vision: "Misión y visión",
  mission_vision_desc:
    "Nuestra misión es ayudar a las PYME a lograr rápidamente el cumplimiento de la CBAM de la UE con más del 90% de precisión, reducir costos y mejorar la eficiencia, al mismo tiempo que apoyamos los objetivos de sostenibilidad para 2026.",
  team: "Introducción del equipo",
  team_desc:
    "TaxEcoBit es una plataforma SaaS de cumplimiento CBAM construida por profesionales, dedicada a proporcionar herramientas eficientes y confiables a las PYME para simplificar los procesos de cumplimiento y actualizar continuamente para satisfacer los requisitos regulatorios de la UE.",
  contact: "Contáctenos",
  contact_email: "Correo electrónico: {email}",
  follow_us: "Síganos:",
  newsletter: "Boletín informativo",
  newsletter_desc:
    "Suscríbase a nuestro boletín para obtener las últimas interpretaciones de políticas CBAM, consejos de cumplimiento y actualizaciones de funciones.",
  newsletter_button: "Suscribirse",
  agreement_text:
    "Acepto utilizar este correo electrónico para recibir las últimas interpretaciones de políticas CBAM, consejos de cumplimiento y actualizaciones de funciones, y acepto procesar mis datos personales según los requisitos del RGPD.",
  support: "Soporte instantáneo",
  support_desc:
    "Hemos compilado preguntas frecuentes para su consulta rápida de autoservicio; si necesita más ayuda, puede enviar un ticket en cualquier momento, y nuestro equipo de soporte responderá dentro de 24-48 horas.",
  support_button: "Contactar soporte",
  chat_opened: "Ventana de soporte abierta",
  newsletter_success: "Suscripción exitosa: {email}",
};
